import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcMaximizeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.124 13.116a1.249 1.249 0 1 1 1.766 1.768L7.027 18.75h2.968a1.25 1.25 0 0 1 0 2.5H4A1.25 1.25 0 0 1 2.75 20v-6a1.25 1.25 0 1 1 2.498 0v2.994zM18.752 10V7.006l-3.876 3.878a1.249 1.249 0 1 1-1.766-1.768l3.863-3.866h-2.968a1.25 1.25 0 0 1 0-2.5H20c.69 0 1.249.56 1.249 1.25v6a1.25 1.25 0 1 1-2.498 0"
  }));
}
var IcMaximizeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMaximizeFill));

export { IcMaximizeFill as I };
